import Col from "react-bootstrap/Col";
import { Form } from "antd";
import Row from "react-bootstrap/Row";
import UIElement from "../../atoms/UIElement";
import Styled from "styled-components";
import { useEffect } from "react";

export const FormWrap = Styled.div`
.ant-form-item-label > label {
    white-space: normal !important;
    word-break: break-word !important;
    overflow-wrap: break-word !important;
    display: inline-table !important;
    max-width: 100%;
    max-height: 2000px !important;
  }
.btn{
    border: none;
    padding: 10px 30px;
    width: 100%;
}
.center{  
    display: flex;
    justify-content: center;
    align-items: middle;
}
.end{
    display: flex;
    justify-content: end;
}
.start{
    display: flex;
    justify-content: start;
}
.ant-upload.ant-upload-select .ant-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  .anticon {
    margin-inline-end: 0 !important;
  }
}    
`;
const GridBuilder = ({
  formStructureJson,
  handleChange,
  formSubmit,
  loading,
  handleClick,
  handleForgotPassword,
  domainStatus,
  urlLoader,
  initialValues = {},
  handleSelectChange,
  handleBack,
  isModalOpen = false,
  uploadFile,
  handleNxt,
  disabled = false,
}) => {
  const [form] = Form.useForm();
  const colStyle = {
    flex: "1",
    // padding: "10px",
  };

  useEffect(() => {
    if (
      initialValues.country ||
      initialValues.competencyQC ||
      initialValues.competencyrole ||
      initialValues.location
    ) {
      form.setFieldsValue({
        country: initialValues?.country,
        competencyQC: initialValues?.competencyQC,
        competencyrole: initialValues?.competencyrole,
        location: initialValues?.location,
        serviceline: initialValues?.serviceline,
        subserviceline: initialValues?.subserviceline,
        department: initialValues?.department,
        grade: initialValues?.grade,
        managingoffice: initialValues?.managingoffice,
        leveldepartmentname: initialValues?.leveldepartmentname,
        contractName: initialValues?.contractName,
        type: initialValues?.type,
        startDate: initialValues?.startDate,
        endDate: initialValues?.endDate,
      });
    } else {
      form.setFieldsValue(initialValues);
    }
  }, [initialValues, form, isModalOpen]);

  return (
    <Form
      form={form}
      onFinish={formSubmit}
      className="email_refer help_form"
      initialValues={initialValues}
      disabled={disabled}
      onFinishFailed={({ errorFields }) => {
        if(errorFields.length > 0){
        form.scrollToField(errorFields[0].name, { behavior: "smooth", block: "center" });
        }
      }}
    >
      <h6>{formStructureJson?.title}</h6>
      {formStructureJson.pages[0]?.fields.map((row, rowIndex) => (
        <Row key={rowIndex}>
          {row?.map((field, colIndex) => {
            return (
              <>
                {field?.length > 1 ? (
                  <Col sm={row?.length === 2 ? 6 : row?.length === 3 ? 4 : 3}>
                    <Row>
                      {field?.map((data) => (
                        <>
                          <Col
                            key={data.id}
                            style={colStyle}
                            sm={
                              formStructureJson.pages[0]?.colSpan[rowIndex][
                                colIndex
                              ]
                            }
                          >
                            <FormWrap>
                              <UIElement
                                label={data?.label}
                                type={data?.type}
                                options={data?.options}
                                name={data?.name}
                                position={field?.position}
                                background={field?.background}
                                textColor={field?.textColor}
                                disabled={field?.disabled}
                                row={field?.row}
                                Placeholder={field?.Placeholder}
                                picker={field?.picker}
                                maxLength={field?.maxLength}
                                required={field?.required}
                                value={field?.value}
                                content={field?.content}
                                handleChange={handleChange}
                                handleSelectChange={handleSelectChange}
                                readOnly={field?.readOnly}
                                viewOnly={field?.viewOnly}
                                event={field?.event}
                                loading={loading}
                                handleClick={() => handleClick()}
                                handleBack={() => handleBack()}
                                className={data?.position}
                                validationRules={data?.validationRules}
                                handleForgotPassword={handleForgotPassword}
                                onKeyDown={data?.onKeyDown}
                                suffixUrl={data?.suffixUrl}
                                domainStatus={domainStatus}
                                urlLoader={urlLoader}
                                link={data?.link}
                                form={form}
                                buttons={field?.buttons}
                                uploadFile={uploadFile}
                                handleNxt={() => handleNxt()}
                                mode={field?.mode}
                                setEmployeeModal={field?.setEmployeeModal}
                              />
                            </FormWrap>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </Col>
                ) : (
                  <Col
                    key={field.id}
                    style={colStyle}
                    sm={formStructureJson.pages[0]?.colSpan[rowIndex]}
                  >
                    <FormWrap>
                      <UIElement
                        label={field?.label}
                        type={field?.type}
                        options={field?.options}
                        name={field?.name}
                        position={field?.position}
                        background={field?.background}
                        textColor={field?.textColor}
                        disabled={field?.disabled}
                        row={field?.row}
                        Placeholder={field?.Placeholder}
                        picker={field?.picker}
                        maxLength={field?.maxLength}
                        required={field?.required}
                        value={field?.value}
                        content={field?.content}
                        handleChange={handleChange}
                        handleSelectChange={handleSelectChange}
                        readOnly={field?.readOnly}
                        event={field?.event}
                        loading={loading}
                        handleClick={() => handleClick()}
                        handleBack={() => handleBack()}
                        className={field?.position}
                        validationRules={field?.validationRules}
                        handleForgotPassword={handleForgotPassword}
                        onKeyDown={field?.onKeyDown}
                        viewOnly={field?.viewOnly}
                        suffixUrl={field?.suffixUrl}
                        domainStatus={domainStatus}
                        urlLoader={urlLoader}
                        link={field?.link}
                        form={form}
                        buttons={field?.buttons}
                        uploadFile={uploadFile}
                        handleNxt={() => handleNxt()}
                        mode={field?.mode}
                        setEmployeeModal={field?.setEmployeeModal}
                      />
                    </FormWrap>
                  </Col>
                )}
              </>
            );
          })}
        </Row>
      ))}
    </Form>
  );
};

export default GridBuilder;
